const primaryMain = '#5a0722';
const primaryMainOpacity = 'rgba(90, 7, 34, 0.9)';
const tertiaryMain = '#930a37';
const secondaryMain = '#eaaa00';
const secondaryMainOpacity = 'rgba(234, 170, 0, 0.5)';
const secondaryLight = '#f8bf27';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
